import { useEffect, useState } from "react"
import AwardInterface from "../../../interfaces/Award.interface"
import { Link } from "react-router-dom"
import { getAllAwardsService } from "../../../services/awards.services"
import { setAwards } from "../../../store/features/awardsSlice"
import { toast } from "react-toastify"
import Content from "../../../components/Content"

const AwardsMainPage = () => {
    const [awards, setAwards] = useState<AwardInterface[]>([])
    useEffect(() => {
        getAllAwardsService()
        .then((res) => setAwards(res.data.payload.awards))
        .catch((error) => toast.error(error.response.data.message))
        .finally(() => {})
    }, [])
    return (
        <div>
            <Content>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="gap-2 px-6 py-3">
                                Nombre
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Descripción
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {awards.map(award => (
                            <tr key={award?.id as string} className="bg-white border-b">
                                <td className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                    <Link to={`/awards/${award.id}/overview`}>{award?.name}</Link>
                                </td>
                                <td className="px-6 py-4">
                                    <p className="text-zinc-500">{award.description}</p>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Content>
        </div>
    )
}

export default AwardsMainPage